var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"gallery__item",attrs:{"href":_vm.get_src,"target":"_blank","data-pswp-width":_vm.width,"data-pswp-height":_vm.height,"rel":"noreferrer"}},[_c('lazy-image',{attrs:{"cover_img":"","src":_vm.image_src,"lazy_src":_vm.image_src_lazy}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }